// M147 (2026-05-12): Header chung cho TẤT CẢ admin pages.
//
// Mục đích: đồng nhất layout/vị trí "← Trang admin" + title + subtitle + action buttons.
// Trước đây mỗi page tự thiết kế header → vị trí và style khác nhau.
//
// Props:
//   - title: string — bắt buộc (vd "Câu hỏi (6 bộ)")
//   - subtitle: string|node — optional (mô tả ngắn dưới title)
//   - backTo: string — default '/admin' (URL khi bấm back)
//   - backLabel: string — default 'Trang admin'
//   - actions: node — slot cho buttons bên phải (vd "+ Thêm", "Export")
//   - status: node — slot nhỏ giữa title và actions (vd badge "Đã lưu")
//
// Pattern dùng:
//   <AdminPageHeader
//     title="Tên trang"
//     subtitle="Mô tả ngắn"
//     actions={<>
//       <button>...</button>
//     </>}
//   />

import { Link } from 'react-router-dom';

export default function AdminPageHeader({
  title,
  subtitle,
  backTo = '/admin',
  backLabel = 'Trang admin',
  actions,
  status,
}) {
  return (
    <div className="mb-4 md:mb-5 pb-3 md:pb-4 border-b border-slate-200">
      {/* M148 (2026-05-12): Mobile-first — back link standalone row, title to lớn rõ, actions wrap full-width mobile */}
      <Link
        to={backTo}
        className="btn-icon inline-flex items-center gap-1 text-sm text-slate-500 hover:text-brand-700 transition-colors no-select"
      >
        <span aria-hidden>←</span>
        <span>{backLabel}</span>
      </Link>
      <div className="mt-1.5 flex items-start justify-between gap-3 flex-wrap">
        <div className="min-w-0 flex-1">
          <h1 className="text-xl md:text-2xl font-bold text-slate-800 leading-tight">{title}</h1>
          {subtitle && (
            <div className="text-sm text-slate-500 mt-1 leading-snug">{subtitle}</div>
          )}
        </div>
        {(actions || status) && (
          <div className="flex flex-wrap items-center gap-2 w-full md:w-auto">
            {status}
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
